import { css } from 'emotion';
import { weaveBlue } from '../../styles/colors';

export const modalBackgroundColor = 'rgba(51, 65, 72, 0.9)'; // #334148e6

export const modalBackdrop = css`
  background-color: ${modalBackgroundColor};
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1; // This is because of back button
  label: modal-backdrop;
`;

export const reactModalBody = css`
  border-radius: 10px;
  label: react-modal-body;
`;

export const modalCard = css`
  background-color: white;
  overflow: hidden;
  border-radius: 10px;
  label: modal-card;
`;

export const modalHeader = css`
  background-color: ${weaveBlue};
  position: relative;
  display: flex;
  margin: 0 auto;
  max-height: 35px;
  padding: 5px;
  color: white;
  font-size: 1.3em;
  justify-content: center;

  label: modal-header;
`;
